module.exports = __webpack_public_path__ + "static/media/Menifistation.30b54560.jpg";